import { Cart } from "../../types/cart";

export interface FormData {
  items: FormDataItem[];
}

export interface FormDataItem {
  productId: string;
  quantity: number;
  selected: boolean;
  price: number;
  discountPrice: number;
}

function getItemsTotal(cart: Cart) {
  if (!cart) return;

  return cart.items.map((item) => {
    const cartPrice = item.discountPrice ? item.discountPrice : item.product.price;
    return item.quantity * cartPrice;
  });
}

function convertToOrder(items: FormDataItem[]) {
  return items
    .filter((i) => i.selected)
    .map((i) => {
      return {
        discountPrice: i.discountPrice,
        productId: i.productId,
        quantity: i.quantity,
      };
    });
}

function convertCartToFormData(cart: Cart) {
  return {
    items: cart.items.map((i) => {
      return {
        discountPrice: i.discountPrice,
        price: i.itemPrice,
        productId: i.product.id,
        quantity: i.quantity,
        selected: true,
      };
    }),
  };
}

export { getItemsTotal, convertToOrder, convertCartToFormData };
